import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameStyle } from "../style/GameStyle";
/**
 * Properties for a firework burst.
 */
export class GameFireworkBurstProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.headProperties = new SpineProperties(GameStyle.FIREWORK_SYMBOL, GameStyle.MODULE);
        this.tailProperties = {
            emit: false,
            autoUpdate: true,
            frequency: 0.001,
            maxParticles: 1000,
            pos: { x: 0, y: 0 },
            lifetime: { min: 0.3, max: 0.3 },
            behaviors: [
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 1, time: 0 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-Particle"
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 180,
                        },
                        minStart: 0,
                        maxStart: 50,
                        rotate: true,
                    }
                },
            ],
        };
        this.glowProperties = {
            distance: 15,
            outerStrength: 5,
        };
        this.frequency = 0.01;
        this.angle = { min: -80, max: 45 };
        this.distance = { min: 300, max: 400 };
        this.offset = { min: 170, max: 230 };
        this.duration = { min: 0.3, max: 0.5 };
        this.colours = [
            0x308dd0,
            0xf7843a,
            0xceca03,
            0xe1420f,
            0xfad315,
            0xd0f249,
            0xf89105,
            0x9bc433,
            0xd3b800,
            0xdc5acf,
        ];
    }
}
//# sourceMappingURL=GameFireworkBurstProperties.js.map